import { render, staticRenderFns } from "./AddBanner.vue?vue&type=template&id=f12e41ca&scoped=true&"
import script from "./AddBanner.vue?vue&type=script&lang=js&"
export * from "./AddBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12e41ca",
  null
  
)

export default component.exports